import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { TweenMax } from 'gsap';
import EFVideo from '@/components/UI/EFVideo';

export default function DSection() {
    const { useEffect, useLang, useRef } = useGlobal()
    const { t } = useLang('xboost')
    const videoRef = useRef(null)

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        const scene1 = new ScrollMagic.Scene({
            triggerElement: '.D_section .textBox .title',
            offset: 100,
            triggerHook: 1,
            duration: 200,
        })
            .setTween(TweenMax.to('.D_section .textBox .title', 0.5, { opacity: 1 }))
            .addTo(controller);

        const scene2 = new ScrollMagic.Scene({
            triggerElement: '.D_section .textBox .text',
            offset: 100,
            triggerHook: 1,
            duration: 200,
        })
            .setTween(TweenMax.to('.D_section .textBox .text', 0.5, { opacity: 1 }))
            .addTo(controller);
    }, []);

    useEffect(() => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
        const videoEl = document.querySelector('.xboost .D_section .video') as HTMLElement;
        // 进入视频区域则立即为显示视频第一帧
        new ScrollMagic.Scene({
            triggerElement: '.D_section .videoBox',
            triggerHook: 1,
        })
            .on('enter', () => {
                videoEl.currentTime = 0;
            })
            .addTo(controller);

        // 进入视频区80%后开始播放
        const scene = new ScrollMagic.Scene({
            triggerElement: '.D_section .videoBox',
            triggerHook: 1,
            offset: layoutH * 0.8,
        });
        scene.on('enter', () => {
            videoRef?.current?.play();
        });
        scene.addTo(controller);
    }, []);

    return (
        <div className={`D_section ${css.D_section}`}>
            <div className="videoBox">
                <div className="video-box-bottom">
                    <EFVideo
                        sources={["/video/xboost/04_BMS.webm", "/video/xboost/04_BMS.mp4"]}
                        ref={videoRef}
                        className="video"
                        width="100%"
                        height="100%"
                        autoPlay={false}
                        loop={false}
                    />
                </div>
                <div className="textBox">
                    <p className="title">{t('section_4_title')}</p>
                    <p className="text">{t('section_4_desc')}</p>
                </div>
            </div>
        </div>
    );
}
